import $ from 'jquery';
import { useContext, useEffect, useState } from "react";
import Form from "../controls/Form";
import Input from "../controls/Input";
import { Link } from "react-router-dom";
import { AccountContext } from "../Account/AccountContext";

export default (props) => {

	const [view, setView] = useState('login');
	const { login } = useContext(AccountContext);
	if (view != 'resetpassword' && props.resetPassword) {
		setView('resetpassword');
	} else if (view != 'redir' && props.redir) {
		setView('redir');
	}

	useEffect(() => {
		$('html, body').css({ height: '100%' });
		$('body').removeClass().addClass("d-flex align-items-center py-4 bg-body-tertiary");
		$('#Main').removeClass().addClass("form-signin w-100 m-auto").css({ maxWidth: 330 });
		return () => {
			$('html, body').css({ height: '' });
			$('body').removeClass();
			$('#Main').removeClass().css({ maxWidth: '' });
		}
	}, [])

	const changeView = (e, view) => {
		e.preventDefault();
		setView(view);
	}

	return (
		<>
			<h1 className="display-3 mb-3 fw-normal">{t.appName}</h1>
			{view == 'lostpassword' ? <Form action="account/lostpassword" onSuccess={() => setView('login')}>
				<p className="h5">{t.loginLostPassword}</p>
				<Input key="lst" name="login" label={t.loginEmailOrUser} type="text" required >
					<span className="input-group-text">
						<span className="fa-regular fa-envelope" > </span>
					</span>
				</Input>
				<button className="btn btn-primary w-100 py-2 my-2">{t.commonSend}</button>
				<a href="#" onClick={e => changeView(e, 'login')}>{t.loginBackToLogin}</a>
			</Form> : view == 'resetpassword' ?
				<Form action="account/resetpassword" redirectOnSuccess="/">
					<p className="h5">{t.loginNewPassword}</p>
					<Input name="hash" type="hidden" value={props.hash} />
					<Input name="password" label={t.loginNewPassword} type="password" required>
						<span className="input-group-text">
							<span className="fa-solid fa-key"></span>
						</span>
					</Input>
					<Input name="password2" label={t.loginNewPasswordAgain} type="password" required>
						<span className="input-group-text">
							<span className="fa-solid fa-key"></span>
						</span>
					</Input>
					<button className="btn btn-primary w-100 py-2 my-2">{t.commonSend}</button>
					<Link to="/">{t.loginBackToLogin}</Link>
				</Form> : view == 'redir' ?
					<div>{props.redir}</div> :
					<Form action="account/signin" onSuccess={login}>
						<Input name="login" label={t.loginEmailOrUser} type="text" value="" required>
							<span className="input-group-text">
								<span className="fa-regular fa-envelope"></span>
							</span>
						</Input>
						<Input name="password" label={t.loginPassword} type="password" value="" required>
							<span className="input-group-text">
								<span className="fa-solid fa-key"></span>
							</span>
						</Input>
						<button className="btn btn-primary w-100 py-2 my-2">{t.loginLogin}</button>
						<a href="#" onClick={e => changeView(e, 'lostpassword')}>{t.loginLostPassword}</a>
					</Form>
			}
		</>

	);
}